import React, { useEffect, useState } from "react";
import Layout from "../components/layoutBlack";
import axios from "axios";
import { config } from "../utils/constants";
import { Link, useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import Breadcrumbs from "../components/breadcrumbs";
import { Helmet } from "react-helmet-async";


const Blog = () => {
  const REACT_APP_API_URL = config.url.REACT_APP_API_URL;
  const REACT_API_IMAGE_URL = config.url.REACT_API_IMAGE_URL;

  const [blogData, setBlogData] = useState([]);
  const [last4BlogData, setLast4BlogData] = useState([]);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;

  useEffect(() => {
    axios
      .get(`${REACT_APP_API_URL}/blogs/`)
      .then((res) => {
        setBlogData(res.data["blogs"]);
        setLast4BlogData(res.data["last_4_blogs"]);
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  // Calculate pagination indexes
  const totalPages = Math.ceil(blogData.length / blogsPerPage);
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogData.slice(indexOfFirstBlog, indexOfLastBlog);

  // --- SEO values ---
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://molu.co";
  const canonical = `${origin}/blog`;

  const metaTitle = "Molu Blog | Science-Driven Hair & Skin Care";
  const metaDescription =
    "Read Molu’s latest research-backed articles on hair growth, skincare, peptides (GHK-Cu, AHK-Cu), and performance wellness.";
  const metaKeywords =
    "Molu blog, hair growth, skincare, GHK-Cu, AHK-Cu, peptides, 2-deoxy-D-ribose, longevity, wellness";
    
  const ogImage = "https://molu.co/assets/images/og/molu-banner-1200x630.png";

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div>
      <Layout>
        <Helmet prioritizeSeoTags>
          <title>{metaTitle}</title>
          <meta key="desc" name="description" content={metaDescription} />
          <meta key="keywords" name="keywords" content={metaKeywords} />
          <link rel="canonical" href={canonical} />

          {/* Open Graph */}
          <meta key="og:type" property="og:type" content="website" />
          <meta key="og:title" property="og:title" content={metaTitle} />
          <meta
            key="og:description"
            property="og:description"
            content={metaDescription}
          />
          <meta key="og:image" property="og:image" content={ogImage} />
          <meta key="og:url" property="og:url" content={canonical} />
          <meta key="fb:app_id" property="fb:app_id" content="1514691803168501" />

          {/* Twitter */}
          <meta
            key="twitter:card"
            name="twitter:card"
            content="summary_large_image"
          />
          <meta
            key="twitter:title"
            name="twitter:title"
            content={metaTitle}
          />
          <meta
            key="twitter:description"
            name="twitter:description"
            content={metaDescription}
          />
          <meta key="twitter:image" name="twitter:image" content={ogImage} />
        </Helmet>

        <div className="container  p-t-80 p-b-10">
          <Breadcrumbs />
        </div>

        {/* Content Section */}
        <section className="full-page-section bg0 p-t-40 p-b-60">
          <div className="container">
            <div className="row">
              {/* Blog Posts */}
              <div className="col-md-8 col-lg-9 p-b-80">
                <div className="p-r-45 p-r-0-lg">
                  <div className="row">
                    {currentBlogs.map((post) => (
                      <div key={post.id} className="col-12 col-md-6 col-lg-4 p-b-30">
                        <div className="h-100 d-flex flex-column">
                          <div
                            onClick={() => navigate(`/blog/blog-detail/?title=${post.slug}`)}
                            style={{ cursor: "pointer" }}
                            className="hov-img0 how-pos5-parent"
                          >
                            <img
                              src={`${REACT_API_IMAGE_URL}${post.lead_image}`}
                              alt={`Blog ${post.id}`}
                              style={{ width: "100%", height: "auto", display: "block" }}
                            />
                          </div>

                          {/* Body also flex column so we can push footer */}
                          <div className="p-t-20 d-flex flex-column flex-grow-1">
                            <h4 className="p-b-10">
                              <div
                                className="ltext-108 cl2 hov-cl1 trans-04"
                                onClick={() => navigate(`/blog/blog-detail/?title=${post.slug}`)}
                                style={{ cursor: "pointer" }}
                              >
                                {post.title}
                              </div>
                            </h4>

                            <span className="stext-117 cl6">
                              {parse(post.teaser_text)}
                            </span>

                            {/* THIS goes to the bottom */}
                            <div className="flex-w flex-sb-m p-t-18 mt-auto">
                              <span className="flex-w flex-m stext-111 cl2 p-r-30 m-tb-10">
                                <span>
                                  <span className="cl4">By</span> Admin
                                  <span className="cl12 m-l-4 m-r-6">|</span>
                                </span>
                                <span>Comments</span>
                              </span>

                              <div
                                className="stext-101 cl2 hov-cl1 trans-04 m-tb-10"
                                onClick={() => navigate(`/blog/blog-detail/?title=${post.slug}`)}
                                style={{ cursor: "pointer" }}
                              >
                                Continue Reading
                                <i className="fa fa-long-arrow-right m-l-9"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* Pagination */}
                  <div className="flex-l-m flex-w w-full p-t-10 m-lr--7">
                    <button
                      className={`flex-c-m how-pagination1 trans-04 m-all-7 ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                      onClick={prevPage}
                      disabled={currentPage === 1}
                    >
                      Prev
                    </button>

                    {[...Array(totalPages)].map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentPage(index + 1)}
                        className={`flex-c-m how-pagination1 trans-04 m-all-7 ${
                          currentPage === index + 1 ? "active-pagination1" : ""
                        }`}
                      >
                        {index + 1}
                      </button>
                    ))}

                    <button
                      className={`flex-c-m how-pagination1 trans-04 m-all-7 ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                      onClick={nextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-md-4 col-lg-3 p-b-80">
                <div className="side-menu">
                  {/* Recent Posts */}
                  <div className="p-t-55">
                    <h4 className="mtext-112 cl2 p-b-33">Recent Posts</h4>
                    <ul>
                      {last4BlogData.map((blog) => (
                        <li className="bor18" key={blog.id}>
                          <Link
                            to={`/blog/blog-detail?title=${blog.slug}`}
                            className="dis-block stext-115 cl6 hov-cl1 trans-04 p-tb-8 p-lr-4"
                          >
                            {blog.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Tags */}
                  {/* <div className="p-t-50">
                    <h4 className="mtext-112 cl2 p-b-27">Tags</h4>
                    <div className="flex-w m-r--5">
                      {blogData.slice(0, 4).flatMap((blog) =>
                        blog.meta_keywords.split(",").map((tag, index) => (
                          <a
                            key={`${blog.id}-${index}`}
                            href="/"
                            className="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5"
                          >
                            {tag.trim()}
                          </a>
                        ))
                      )}
                    </div>
                  </div> */}
                </div>
              </div>
              {/* end sidebar */}
            </div>
          </div>
        </section>
      </Layout>
    </div>
  );
};

export default Blog;
